module.exports = __webpack_public_path__ + "img/Innoscience.3ccf6ce2.png";